import React from 'react';
import ReactEcharts from 'echarts-for-react';
import * as echarts from 'echarts';

const EntityValuePieChart = () => {
  // Data for the business value components
  const data = [
    {
      value: 879892.05,
      name: 'Underlying Business Assets',
      itemStyle: {
        color: '#2F80F7' // Blue color for Underlying Business Assets
      }
    },
    {
      value: 1062619.72,
      name: 'Estimated Goodwill',
      itemStyle: {
        color: '#A3E566' // Green color for Estimated Goodwill
      }
    },
    {
      value: 698311.10,
      name: 'Surplus Asset/(Liabilities)',
      itemStyle: {
        color: '#FF6347' // Red color for Surplus Asset/(Liabilities)
      }
    }
  ];

  // Option for the pie chart
  const option = {
    title: {
      text: 'Chart Entity Value Components',
      subtext: 'Underlying Business Assets vs Estimated Goodwill vs Surplus Asset/(Liabilities)',
      left: 'center',
      top: 'top',
      textStyle: {
        fontWeight: 'bold',
        fontSize: 16
      }
    },
    tooltip: {
      trigger: 'item',
      formatter: '{b}: ${c} ({d}%)'
    },
    series: [
      {
        name: 'Business Value',
        type: 'pie',
        radius: '50%',
        data: data,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };

  return (
    <ReactEcharts
      option={option}
      echarts={echarts}
      style={{ height: '400px', width: '100%' }}
    />
  );
};

export default EntityValuePieChart;
